
import {
  Home,
  Briefcase,
  HelpCircle,
  Wand2,
  LogIn,
  Users,
  BookOpen,
  TrendingUp
} from 'lucide-react';
import { MenuItemData, SpotlightData } from './types';

export const spotlight: SpotlightData = {
  name: "Project Wizard",
  tagline: "AI-Powered Project Planning",
  description: "Get intelligent recommendations and build specifications for your perfect website or web application.",
  icon: Wand2,
  image: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&w=900&q=80",
  href: "/website-wizard?fresh=true",
  cta: "Start Your Project",
};

export const column1Items: MenuItemData[] = [
  {
    name: 'Homepage',
    icon: Home,
    description: "Return to our main page and explore our full range of services.",
    href: '/',
    cta: "Go Home"
  },
  {
    name: 'About Us',
    icon: Users,
    description: "Learn about our mission, values, and the expert team behind our AI-powered solutions.",
    href: '/about',
    cta: "Learn More"
  },
  {
    name: 'Business Insights',
    icon: BookOpen,
    description: "Stay updated with the latest insights, trends, and news from our industry experts.",
    href: '/blog',
    cta: "Read Insights"
  },
];

export const column2Items: MenuItemData[] = [
  {
    name: 'Careers',
    icon: Briefcase,
    description: "Join our innovative team and help shape the future of AI-powered solutions.",
    href: '/careers',
    cta: "View Opportunities"
  },
  {
    name: 'FAQs',
    icon: HelpCircle,
    description: "Find answers to commonly asked questions about our services.",
    href: '/faq',
    cta: "Get Answers"
  },
  {
    name: 'Client Login',
    icon: LogIn,
    description: "Access your client dashboard and manage your projects with our comprehensive tools.",
    href: '/client-login',
    cta: "Sign In"
  }
];
